import { ContextStore } from 'bernie-plugin-mobx';

import { adaptSearchCriteria } from '../stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from '../stores/current-hotel-store';

import { PropertyFilterAmenity } from '../__generated__/api';

export const isPetsAmenityFilterPresent = (context?: ContextStore, currentHotel?: CurrentHotelStore) => {
  if (!currentHotel || !context) {
    return false;
  }

  const searchCriteria = adaptSearchCriteria(context, currentHotel.searchCriteria);

  const possibleSelectionValuesForPets = [PropertyFilterAmenity.PETS, 'pets_allowed'];

  return (
    (searchCriteria.secondary?.selections &&
      searchCriteria.secondary.selections.some(selection => possibleSelectionValuesForPets.includes(selection.value))) ||
    false
  );
};
